import { mapState } from 'vuex'
import anchorme from 'anchorme'

export default {
  computed: {
    ...mapState({
      showHyperLink: (state) => state.presentation.showHyperLink,
    }),
  },
  data: () => {
    return {
      dataValue: '',
      clickable: false,
    }
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.anchorClickableLink(newValue)
      }
    },
    showHyperLink(value, oldValue) {
      if (value !== oldValue) {
        this.anchorClickableLink(this.value)
      }
    },
  },
  methods: {
    anchorClickableLink(value) {
      if (!value) {
        return ''
      }
      if (!this.showHyperLink) {
        let replaceValue = value.replace(/<a/g, '<span')
        replaceValue = replaceValue ? replaceValue.replace(/text-hyper-link/g, '') : value
        // Remove Zero-Width Space
        replaceValue = replaceValue.replace(/[\u200B-\u200D\uFEFF]/g, '')
        this.dataValue = replaceValue
        this.clickable = false
      }
      this.dataValue = anchorme(value, {
        attributes: [
          {
            name: 'target',
            value: 'blank',
          },
          {
            name: 'class',
            value: 'text-hyper-link',
          },
        ],
      })
      if (this.value !== this.dataValue) {
        this.clickable = true
      } else {
        this.clickable = false
      }
    },
  },
}
